// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ck-audio-wrapper,.ck-audio-wrapper audio{width:100%}", "",{"version":3,"sources":["webpack://./plugins/ckeditor5-audio/theme/audio.css"],"names":[],"mappings":"AAGA,0CACI,UACJ","sourcesContent":[".ck-audio-wrapper {\r\n    width: 100%;\r\n}\r\n.ck-audio-wrapper audio {\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
